var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2911 14.9171C30.7424 12.391 27.3702 11 23.7891 11C20.2081 11 16.8272 12.3945 14.2785 14.9275C13.9216 15.2827 13.8972 15.8781 14.2663 16.2193C14.4334 16.3742 14.6458 16.4508 14.8565 16.4508C15.0793 16.4508 15.3022 16.3655 15.4728 16.1949C17.6977 13.9665 20.652 12.7409 23.7909 12.7409C26.9298 12.7409 29.8737 13.963 32.0968 16.1845C32.4554 16.5431 33.0491 16.5222 33.3816 16.1235C33.6758 15.7701 33.6184 15.2426 33.2911 14.9171Z",
    fill: "url(#paint0_linear_300_2388)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5369 18.9684C30.8311 18.6167 30.7771 18.0875 30.4516 17.7654C28.6637 15.9966 26.2995 15.0234 23.7908 15.0234C21.2822 15.0234 18.9075 16.0001 17.1179 17.7758C16.7627 18.1292 16.7436 18.7246 17.1109 19.0641C17.278 19.2173 17.4887 19.2939 17.7011 19.2939C17.9239 19.2939 18.1468 19.2086 18.3174 19.038C19.7815 17.5704 21.7244 16.7626 23.7908 16.7626C25.8573 16.7626 27.7897 17.5669 29.2521 19.0258C29.6107 19.3844 30.2044 19.3635 30.5369 18.9666V18.9684Z",
    fill: "url(#paint1_linear_300_2388)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9208 20.6446C19.5099 21.0554 19.5952 21.7744 20.1784 22.0564C20.5074 22.2166 20.8991 22.1261 21.1585 21.8684C21.8584 21.172 22.788 20.7873 23.7769 20.7873C24.7657 20.7873 25.7006 21.1738 26.4022 21.8754C26.5728 22.046 26.7956 22.1296 27.0185 22.1296C27.2291 22.1296 27.4398 22.053 27.6052 21.9015C27.9829 21.5551 27.9516 20.9544 27.586 20.5958C26.5606 19.5965 25.2114 19.0464 23.7769 19.0464C22.3424 19.0464 20.9496 19.6139 19.9208 20.6446Z",
    fill: "url(#paint2_linear_300_2388)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 22.3789L23.9511 25.7737C23.8623 25.8137 23.7613 25.8137 23.6725 25.7737L15.7827 22.3737C15.3178 22.1734 14.7312 22.3998 14.5675 23.0091V34.964C14.5675 35.4445 14.9575 35.8344 15.438 35.8344H20.8853C20.9932 35.8344 21.0942 35.8832 21.1604 35.9685L22.4016 37.5579C22.574 37.7773 22.8299 37.8922 23.0876 37.8922C23.2825 37.8922 23.4793 37.8278 23.6412 37.6937C24.0102 37.3891 24.0416 36.832 23.7474 36.4542L22.1649 34.4278C21.9995 34.2171 21.7471 34.0935 21.479 34.0935H16.6549C16.4634 34.0935 16.3067 33.9368 16.3067 33.7453V25.0251C16.3067 24.7744 16.5626 24.6055 16.7924 24.7047L23.4706 27.5825C23.6934 27.6782 23.9458 27.6765 24.1669 27.579L30.6153 24.7256C30.8451 24.6229 31.1045 24.7918 31.1045 25.0442V35.6586C31.1045 35.8501 30.9478 36.0068 30.7563 36.0068H28.0248C27.9116 36.0068 27.8037 35.9511 27.7393 35.8571L26.6808 34.3338C26.3901 33.9159 25.7982 33.8306 25.4012 34.1684C25.0548 34.4626 25.013 34.9849 25.2742 35.3592L26.6756 37.3734C26.8375 37.6067 27.1056 37.7477 27.3911 37.7477H31.9784C32.4589 37.7477 32.8489 37.3577 32.8489 36.8772V23.2023C32.8489 22.9969 32.7897 22.7915 32.6609 22.6296C32.4032 22.3092 31.9784 22.2187 31.625 22.3737V22.3789Z",
    fill: "url(#paint3_linear_300_2388)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_2388",
    x1: 13.4342,
    y1: 20.0719,
    x2: 49.2083,
    y2: 3.09797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8FF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00D4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#61A3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0048AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_300_2388",
    x1: 14.5848,
    y1: 22.5007,
    x2: 50.359,
    y2: 5.52673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8FF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00D4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#61A3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0048AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_300_2388",
    x1: 15.7373,
    y1: 24.9255,
    x2: 51.5115,
    y2: 7.95326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8FF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00D4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#61A3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0048AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_300_2388",
    x1: 19.1775,
    y1: 32.1785,
    x2: 54.9516,
    y2: 15.2046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8FF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00D4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#61A3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0048AA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.744c15b396dd2dfa77b9acfd4b75a812.svg";
export { ForwardRef as ReactComponent };